<template>
    <v-dialog v-model="shows" max-width="1080" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="isLoaded" height="100%">
            <v-card-title>
                <template v-if="isCreate">작가 생성</template>
                <template v-else>작가 상세</template>
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="pa-0" style="max-height: calc(90vh - 120px); overflow-y: auto">
                <v-row no-gutters>
                    <v-col>
                        <v-card-subtitle>기본 정보</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-row class="ma-n2">
                                <v-col class="pa-2" cols="12" md="5">
                                    <view-section-field label="썸네일" v-bind="attrs_input">
                                        <v-card flat class="py-3" style="overflow: hidden">
                                            <image-input v-model="form.thumb" :aspect-ratio="1 / 1" flat class="rounded" style="overflow: hidden" />
                                        </v-card>
                                    </view-section-field>
                                </v-col>
                                <v-col class="pa-2" cols="12" md="7">
                                    <v-row class="ma-n2">
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="표시순서" v-model="form.index" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <view-section-field label="표시여부" v-bind="attrs_input">
                                                <v-layout align-center>
                                                    <v-switch v-model="form.shows" v-bind="attrs_switch" class="my-2" />
                                                </v-layout>
                                            </view-section-field>
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="국가(국문)" v-model="form.country.ko" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="국가(영문)" v-model="form.country.en" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="이름(국문)" v-model="form.name.ko" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="이름(영문)" v-model="form.name.en" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="생년월일" type="date" v-model="form.bornAt" v-bind="attrs_input" clearable />
                                        </v-col>
                                        <v-col class="pa-2" cols="12" md="6">
                                            <v-text-field label="생몰월일" type="date" v-model="form.diedAt" v-bind="attrs_input" clearable />
                                        </v-col>
                                        <v-col class="pa-2" cols="12">
                                            <v-textarea label="설명" v-model="form.content" v-bind="attrs_input" rows="7" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn large color="primary" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_switch } from "@/assets/variables";

import ImageInput from "@/components/console/dumb/image-input.vue";
import ViewSectionField from "@/components/console/dumb/view-section-field.vue";

const initAuthor = () => ({
    name: {
        ko: null,
        en: null,
    },
    country: {
        ko: null,
        en: null,
    },
    content: null,
    bornAt: null,
    diedAt: null,
});

export default {
    components: {
        ImageInput,
        ViewSectionField,
    },
    props: {
        value: { type: Object },
    },
    data: () => ({
        shows: false,
        isLoaded: false,
        form: {},

        attrs_input,
        attrs_switch,
    }),
    computed: {
        _author() {
            return this.value?._id;
        },
        isCreate() {
            return !this._author;
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            if (this.isCreate) {
                this.form = { ...initAuthor() };
            } else {
                const { author } = await api.console.auction.authors.get({ _id: this._author });

                author.bornAt = author?.bornAt?.toDate?.() || author.bornAt;
                author.diedAt = author?.diedAt?.toDate?.() || author.diedAt;
                this.form = author;
            }
            this.isLoaded = true;
        },

        validate() {},

        async save() {
            try {
                this.validate();

                let { _thumb, thumb, ...form } = this.form;

                // Document POST / PUT
                const { post, put } = api.console.auction.authors;
                let { author } = await (this.isCreate ? post : put)(form);

                // Thumb POST / DELETE
                if (thumb instanceof File) {
                    thumb = (await api.console.auction.files.post({ _author: author._id, index: "thumb" }, thumb))?.file;
                }
                if (_thumb && _thumb != thumb?._id) {
                    await api.console.auction.files.delete({ _id: _thumb });
                }
                _thumb = thumb?._id || null;

                // Document PUT
                author = (await put({ _id: author._id, _thumb }))?.author;

                alert("저장되었습니다");
                this.$emit("input", author);
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>
